import { gql } from 'apollo-boost';

export const investmentById = gql`
  query ($id: ID) {
    allInvestments(filters: {id: $id}) {
      edges {
          node {
              dbId
              message
          }
      }
    }
  }
`;
